import { render, staticRenderFns } from "./toast.vue?vue&type=template&id=5bc20e7a&scoped=true&"
import script from "./toast.vue?vue&type=script&lang=js&"
export * from "./toast.vue?vue&type=script&lang=js&"
import style0 from "./toast.vue?vue&type=style&index=0&id=5bc20e7a&lang=less&scoped=true&"
import style1 from "./toast.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bc20e7a",
  null
  
)

component.options.__file = "toast.vue"
export default component.exports